import { FetchResult } from '@apollo/client';
import { FieldValidator } from '@prismamedia/one-components';
import { replaceParams } from '../../../routing/Router';
import { paths } from '../../../routing/Router/paths';
import {
  CreateUserMutation,
  GetUserQuery_query_user_User,
  UpdateUserMutation,
  UserCreationInput,
  UserUpdateInput,
} from '../../../__generated__/queries-auth';

export const emptyItem: GetUserQuery_query_user_User = {
  __typename: 'User',
  id: '',
  name: '',
  createdAt: '',
  email: '',
  avatarUrl: null,
  roles: [],
};

export const saveMandatoryFields: FieldValidator<
  GetUserQuery_query_user_User
>[] = [
  {
    label: 'Nom',
    validate: ({ name }) => !!name,
  },
  {
    label: 'Email',
    validate: ({ email }) => !!email,
  },
  {
    label: "Rôle de l'utilisateur",
    // TO DO REWORK ROLES
    validate: ({ roles }) => !!roles[0],
  },
];

export const onSave = async (
  item: GetUserQuery_query_user_User | undefined,
  isCreate: boolean,
  history: any,
  setSaveLoading: (loading: boolean) => void,
  createItem: (
    data: UserCreationInput,
  ) => Promise<
    FetchResult<CreateUserMutation, Record<string, any>, Record<string, any>>
  >,
  updateItem: (
    id: string,
    data: UserUpdateInput,
  ) => Promise<
    FetchResult<UpdateUserMutation, Record<string, any>, Record<string, any>>
  >,
) => {
  if (item) {
    setSaveLoading(true);
    const res = isCreate
      ? await createItem({
          name: item.name,
          email: item.email,
        })
      : await updateItem(item.id, {
          name: item.name,
        });
    setSaveLoading(false);
    if (res && isCreate) {
      history.replace(
        replaceParams(paths.USER_EDIT, {
          id: (res.data as CreateUserMutation).createUser.id,
        }),
      );
    }
  }
};
